import { mapDTO } from '@twistezo/ts-dto-mapper'

import { ViewportSchema } from 'features/globalSetup/features/viewport/forms/ViewportForm/schema'
import { ViewportAttributeDTO } from 'features/globalSetup/features/viewport/types/viewportAttributeDTO'
import { adUnitSizeToDTO } from 'features/globalSetup/features/viewport/utils'

type From = ViewportSchema
type To = ViewportAttributeDTO

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const {
      bannerEnabled,
      bannerSizes,
      minimumWidth,
      name,
      nativeEnabled,
      playerSize,
      videoEnabled,
      viewportId,
    } = data

    return {
      bannerEnabled,
      bannerSizes: bannerSizes.map(adUnitSizeToDTO),
      id: viewportId || null,
      minimumWidth: minimumWidth ?? null,
      name: name || null,
      nativeEnabled,
      playerSize: playerSize.map(adUnitSizeToDTO),
      videoEnabled,
    }
  })
